
import { Component, Vue } from 'nuxt-property-decorator'
import ResponsiveImage from '~/components/ResponsiveImage/ResponsiveImage.vue'
import { getExternalCompareMobileHref } from '~/utils/external-links.utils'

@Component({
  components: { ResponsiveImage },
})
export default class BlackFridayPartners extends Vue {
  getProviderHref (slug: string): string {
    return getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath, slug)
  }
}
